import { z } from "zod";
import { apiIntIdSchema } from "./ids.js";
export const instagramConnectionStateSchema = z.enum([
    "NOT_CONNECTED",
    "CONNECTED",
    "DISCONNECTED",
    "ERROR",
]);
export const instagramConnectionPermissionsSchema = z.object({
    canConnect: z.boolean(),
    canDisconnect: z.boolean(),
});
export const instagramConnectedAccountSchema = z.object({
    id: apiIntIdSchema,
    platformEndpointId: apiIntIdSchema,
    instagramUserId: z.string().min(1),
    username: z.string().min(1),
    name: z.string().nullable(),
    accountType: z.enum(["BUSINESS", "MEDIA_CREATOR"]),
    /** Customer-editable name on the endpoint. Null when unset. */
    localName: z.string().nullable(),
});
export const instagramConnectConfigResponseSchema = z.object({
    enabled: z.boolean(),
    metaAppId: z.string().min(1),
    graphApiVersion: z.string().min(1),
    hasExistingConnection: z.boolean(),
    connectionState: instagramConnectionStateSchema,
});
export const instagramConnectionResponseSchema = z.object({
    enabled: z.boolean(),
    state: instagramConnectionStateSchema,
    platformAccountId: apiIntIdSchema.nullable(),
    account: instagramConnectedAccountSchema.nullable(),
    permissions: instagramConnectionPermissionsSchema,
});
export const disconnectInstagramResponseSchema = instagramConnectionResponseSchema;
export const INSTAGRAM_OAUTH_SUCCESS_TYPE = "MULTI_CHAT_INSTAGRAM_OAUTH_SUCCESS";
export const INSTAGRAM_OAUTH_ERROR_TYPE = "MULTI_CHAT_INSTAGRAM_OAUTH_ERROR";
export const instagramOauthSuccessMessageSchema = z.object({
    type: z.literal(INSTAGRAM_OAUTH_SUCCESS_TYPE),
});
export const instagramOauthErrorMessageSchema = z.object({
    type: z.literal(INSTAGRAM_OAUTH_ERROR_TYPE),
    code: z.string().min(1),
});
export const instagramOauthPopupMessageSchema = z.union([
    instagramOauthSuccessMessageSchema,
    instagramOauthErrorMessageSchema,
]);
//# sourceMappingURL=instagram-contracts.js.map